export default function BankAccountCell({ bankAccount, edit, del, onSuccess, className, ...props}) {
  return (
    <>

      <div className={"d-flex justify-content-between align-items-center bg-light-lighten p-2 rounded gap-2 mb-2 "+className}>
        <div>
          <span className="me-2">
            <span className="dripicons-wallet"></span>
          </span>
          {bankAccount.title && <strong>{bankAccount.title}</strong>}
        </div>
        <div className="w-100">
          <div><strong>{bankAccount.IBAN}</strong></div>
          <div><strong>{bankAccount.SWIFT}</strong> <strong>{bankAccount.bank}</strong></div>
        </div>
        {(edit||del) && <div className={"d-inline-flex"}>
          {edit && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-primary ms-1" onClick={()=>edit(bankAccount)}><span className="mdi mdi-pencil" title="Upraviť"></span></button>}
          {del && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-danger ms-1" onClick={()=>del(bankAccount)}><span className="mdi mdi-trash-can" title="Zmazať"></span></button>}
        </div>}
      </div>
    </>
  );
}
